import { render, staticRenderFns } from "./PoemView.vue?vue&type=template&id=5ee948da&"
import script from "./PoemView.vue?vue&type=script&lang=js&"
export * from "./PoemView.vue?vue&type=script&lang=js&"
import style0 from "./PoemView.vue?vue&type=style&index=0&id=5ee948da&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports